"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodashEs = require("lodash-es");
var _react = _interopRequireWildcard(require("react"));
var _analytics = require("../../components/analytics");
var _breakpoints = require("../../components/breakpoints");
var _Text = _interopRequireDefault(require("../../components/Text"));
var _IconLibrary = require("../../packages/IconLibrary");
var _Overlay = _interopRequireWildcard(require("../Overlay"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
// TODO: this should be added at the analytics leve

// TODO: We need to move all the Icons into the CMS at some point so they don't need to be referenced here.
const SOCIAL_ICONS = {
  facebook: _IconLibrary.FacebookIcon,
  twitter: _IconLibrary.TwitterIcon,
  youtube: _IconLibrary.YoutubeIcon,
  instagram: _IconLibrary.InstagramIcon,
  pinterest: _IconLibrary.PinterestIcon,
  whatsapp: _IconLibrary.WhatsAppIcon,
  tiktok: _IconLibrary.TikTokIcon
};
const SocialIcon = function (_ref) {
  let {
    icon = "",
    ...props
  } = _ref;
  const Component = SOCIAL_ICONS[icon.toLowerCase().trim()];
  if (Component) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
      ...props,
      "data-testid": "SocialIcon"
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: icon
  });
};
const GlobalFooterCategoryLinks = (0, _analytics.withAnalytics)(function (_ref2) {
  let {
    title = "",
    links = [],
    showIframe = function () {},
    active,
    categoryPanelId
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CategoryLinks, {
    $active: active,
    ...(categoryPanelId && {
      id: categoryPanelId
    }),
    "data-testid": "GlobalFooterCategoryLinks",
    children: links.map(function (_ref3) {
      let {
        text,
        ...props
      } = _ref3;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CategoryLink, {
        onClick: props.target === "_iframe" && showIframe(props.href),
        additionalAnalytics: {
          categoryTitle: title
        },
        ...props,
        "data-testid": "GlobalFooterCategoryLinks",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: text
        })
      }, text);
    })
  });
})({
  _component: "GlobalFooterCategory"
});
const GlobalFooter = function (_ref4) {
  let {
    id,
    featuredLinks = [],
    categories = [],
    links = [],
    social = [],
    disclaimer,
    copyright,
    syndicated
  } = _ref4;
  const [show] = (0, _Overlay.useOverlay)({
    id: "FooterOverlay"
  });
  const [overlaySrc, setOverlaySrc] = (0, _react.useState)();
  const [ariaLabel, setAriaLabel] = (0, _react.useState)();
  const fireAnalytics = (0, _analytics.useAnalytics)("GlobalFooter");
  const isMobile = (0, _breakpoints.useMobileBreakpoint)();
  const [activeCategory, setActiveCategory] = (0, _react.useState)();
  const updateActiveCategory = function (category) {
    return function () {
      setActiveCategory(function (c) {
        const newState = category !== c ? category : undefined;
        fireAnalytics("categoryClick", {
          category: (0, _lodashEs.unescape)(category),
          action: newState ? "expand" : "collapse"
        });
        return newState;
      });
    };
  };
  const showIframe = function (src, text) {
    return function (event) {
      if (syndicated) {
        return;
      }
      event.preventDefault();
      setOverlaySrc(src);
      setAriaLabel(text);
      show();
    };
  };
  const PrimaryLinks = function () {
    return links.length > 0 || social.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.PrimaryLinks, {
      children: [links.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: links.map(function (_ref5) {
          let {
            text,
            ...props
          } = _ref5;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.PrimaryLink, {
            onClick: props.target === "_iframe" && showIframe(props.href, text),
            ...props,
            "data-testid": "PrimaryLinks",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              children: text
            })
          }, text);
        })
      }), social.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Socials, {
        children: social.map(function (_ref6) {
          let {
            text,
            ...props
          } = _ref6;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Social, {
            ...props,
            "aria-label": text,
            "data-testid": "PrimaryLinks",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SocialIcon, {
              fill: "#FFF",
              $fillForeground: "#000",
              icon: text,
              width: "15px"
            })
          }, text);
        })
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Overlay.default, {
      id: "FooterOverlay",
      src: overlaySrc,
      fit: "lightbox",
      buttonTheme: "light",
      ariaLabel: ariaLabel,
      height: "80dvh"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.GlobalFooterWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.GlobalFooter, {
        id: id,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.FeaturedLinksContainer, {
          children: featuredLinks && featuredLinks.map(function (featuredLink) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.FeaturedLink, {
              ...featuredLink,
              text: undefined,
              "data-testid": "GlobalFooter",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                children: featuredLink.text
              })
            });
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Content, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_breakpoints.TabletBreakpoint, {
            up: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PrimaryLinks, {})
          }), categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Categories, {
            children: categories.map(function (_ref7, index) {
              let {
                title,
                links = []
              } = _ref7;
              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Category, {
                "data-testid": "GlobalFooter",
                children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CategoryTitle, {
                  children: isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.CategoryTitleButton, {
                    onClick: updateActiveCategory(title),
                    "aria-expanded": activeCategory === title,
                    "aria-controls": `categoryPanel${index}`,
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                        children: title
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Carrot, {
                      $active: activeCategory === title,
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.Arrow, {
                        fill: "#FFF",
                        width: "13px"
                      })
                    })]
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                      children: title
                    })
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(GlobalFooterCategoryLinks, {
                  showIframe: showIframe,
                  active: !isMobile || activeCategory === title,
                  title: title,
                  links: links,
                  ...(isMobile && {
                    categoryPanelId: `categoryPanel${index}`
                  })
                })]
              }, title);
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_breakpoints.MobileBreakpoint, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(PrimaryLinks, {})
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Bottom, {
          children: [disclaimer && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Disclaimer, {
            ...disclaimer,
            text: undefined,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              children: disclaimer.text
            })
          }), copyright && /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.Copyright, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
              children: copyright
            })
          })]
        })]
      })
    })]
  });
};
var _default = exports.default = (0, _analytics.withAnalytics)(GlobalFooter)({});